import { ProgramAPI } from '@/api'

export default {
  namespaced: true,
  state: {
    form: {},
  },
  mutations: {

    setForm(state, data) {
      state.form = data;
    },
  },
  actions: {

    async onUpdate({ rootGetters, dispatch, getters, state }) {

      const diff = getters.getDiff();

      // console.log(diff);

      if(!diff.length || diff.find(n => ![ 'fertigation', 'blend' ].includes(n))) {
        await dispatch('program/steps/setCurrentStep', 'general-settings', { root: true });
        // await dispatch('program/steps/setCurrentStepNextFromSelectedStep', 'general-settings', { root: true });
        // console.log('1');

        dispatch('program/fertigation/destroyState', '', { root: true });
        dispatch('program/base-dressing/destroyState', '', { root: true });
        dispatch('program/tests/destroyState', '', { root: true });
        dispatch('program/fertilizers/destroyState', '', { root: true });
        dispatch('program/blend/destroyState', '', { root: true });

        state.form.soilTestId = null;
        state.form.tissueTestId = null;
        state.form.waterTestId = null;
        state.form.mediaAnalysisId = null;
      } else {
        // console.log('2');
        const to_clear = [];
        if(diff.includes('fertigation')) {
          to_clear.push('fertigation')
          dispatch('program/fertigation/destroyState', '', { root: true });
        }
        if(diff.includes('blend')) {
          to_clear.push('blend')
          dispatch('program/blend/destroyState', '', { root: true });
        }
        await ProgramAPI.clearCertainSteps(rootGetters['program/data'].id, to_clear);
      }


    },

    async initData({ rootGetters, commit }) {
      commit('setForm', _.cloneDeep(rootGetters['program/data']));
    },

    async save({ state, rootGetters, dispatch, commit }) {
      await ProgramAPI.updateGeneralStep(rootGetters['program/data'].id, state.form)
      await dispatch('onUpdate');
      console.log(state.form)
      commit('program/saveProgram', _.cloneDeep(state.form), { root: true });
    }
  },
  getters: {

    form(state) {
      return state.form
    },


    getDiff: (state, getters, rootState, rootGetters) => () => {

      const orig_form = rootGetters['program/data'];
      const new_form = state.form;

      const diff = [];

      const add = key => {
        if(!diff.includes(key)) {
          diff.push(key);
        }
      };

      for (const key in new_form) {
        if(new_form[key] !== orig_form[key]) {
          add(key)
        }
      }

      for (const key in orig_form) {
        if(new_form[key] !== orig_form[key]) {
          add(key)
        }
      }

      return diff;
    },
  },
};
